import script from "./Reorder.vue?vue&type=script&setup=true&lang=js"
export * from "./Reorder.vue?vue&type=script&setup=true&lang=js"

import "./Reorder.vue?vue&type=style&index=0&id=3bf72922&lang=css"

const __exports__ = script;

export default __exports__